function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h70v70H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.255 17.527a18.967 18.967 0 00-11.99-.698c-10.185 2.735-16.23 13.226-13.501 23.433",
  stroke: "#371447",
  strokeWidth: 1.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  fillRule: "nonzero",
  d: "M9.469 41.54l5.177 3.966a.523.523 0 00.817-.189l2.914-5.835c.263-.525-.17-1.22-.684-1.1L9.6 40.25c-.515.118-.598.932-.132 1.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.907 30.163c.117 2.656.19 5.43.22 8.32.03 3.03-.176 5.688-.623 7.975 1.265.57 2.674.897 4.233.977 3.088.16 5.713.045 9.005-.285.26-.026 1.964-.205 2.403-.246.824-.078 1.42-.116 1.938-.116 2.718 0 5.418.256 8.1.768-.054-3.607-.056-6.455-.006-8.544.051-2.166.185-4.66.4-7.48-1.33-.776-3.067-1.3-5.216-1.561-3.013-.366-5.522-.264-8.958.181l-.57.075-.55.074c-.438.058-.747.097-1.04.131-.76.089-1.343.133-1.864.133-2.927 0-5.416-.133-7.472-.402z",
  stroke: "#371447",
  strokeWidth: 1.8,
  fill: "#B0F06B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.816 55.578a18.962 18.962 0 0010.658.223c10.185-2.735 16.229-13.227 13.5-23.433",
  stroke: "#371447",
  strokeWidth: 1.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  fillRule: "nonzero",
  d: "M60.451 31.892l-5.015-3.847a.506.506 0 00-.792.183l-2.82 5.656c-.254.51.164 1.183.663 1.068l7.836-1.81c.498-.115.58-.903.128-1.25z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.61 34.026v1.661c.658 0 1.554.02 2.688.062.066-.266.089-.797.069-1.591l-2.757-.132zM25.61 36.899v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.132zM25.61 39.772v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.132zM25.61 42.644v1.662c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.133zM29.48 34.026v1.661c.657 0 1.553.02 2.687.062.066-.266.089-.797.069-1.591l-2.757-.132zM29.48 36.899v1.661c.657 0 1.553.02 2.687.062.066-.267.089-.797.069-1.591l-2.757-.132zM29.48 39.772v1.661c.657 0 1.553.02 2.687.062.066-.267.089-.797.069-1.591l-2.757-.132zM29.48 42.644v1.662c.657 0 1.553.02 2.687.062.066-.267.089-.797.069-1.591l-2.757-.133zM33.348 34.026v1.661c.658 0 1.554.02 2.688.062.066-.266.089-.797.069-1.591l-2.757-.132zM33.348 36.899v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.132zM33.348 39.772v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.132zM33.348 42.644v1.662c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.133zM37.217 34.026v1.661c.658 0 1.554.02 2.688.062.066-.266.089-.797.069-1.591l-2.757-.132zM37.217 36.899v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.132zM37.217 39.772v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.069-1.591l-2.757-.132zM41.086 34.026v1.661c.658 0 1.554.02 2.688.062.066-.266.089-.797.07-1.591l-2.758-.132zM41.086 36.899v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.07-1.591l-2.758-.132zM41.086 39.772v1.661c.658 0 1.554.02 2.688.062.066-.267.089-.797.07-1.591l-2.758-.132z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.056 27.354c-.104-1.283.287-2.094 1.173-2.435 1.328-.511 2.04 1.236 1.472 5.503M41.016 27.354c-.104-1.283.287-2.094 1.173-2.435 1.328-.511 2.04 1.236 1.472 5.503",
  stroke: "#371447",
  strokeWidth: 1.71
}));

function SvgRecurringTransfersLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRecurringTransfersLg;